import { Injectable } from "@angular/core";
import { User } from "../../../../entities/User";
import { Credentials } from "../../../../entities/Credentials";
import { environment } from "../../../../../environments/environment";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { catchError, map, Observable, retry, Subject, throwError } from "rxjs";
import { BaseServicesService } from "./base-services.service";
import { ChangePassword } from "../../../../entities/ChangePassword";
import { ReiniciarPassword } from "../../../../entities/ReiniciarPassword";
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: "root",
})
export class AuthServiceService extends BaseServicesService {
  private authenticationChanged = new Subject<boolean>();
  private user = new User();
  public statusAuth:number;

  constructor(private http: HttpClient) {
    super();
  }

  public isAuthenticated(): boolean {
    return !(
      sessionStorage.getItem("token") === undefined ||
      sessionStorage.getItem("token") === null ||
      sessionStorage.getItem("token") === "null" ||
      sessionStorage.getItem("token") === "undefined" ||
      sessionStorage.getItem("token") === ""
    );
  }

  clearUserData() {
    this.user = null;
    sessionStorage.clear();

    // Emitir cambio en la autenticación
    this.authenticationChanged.next(false);
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (
      sessionStorage.getItem("token") === undefined ||
      sessionStorage.getItem("token") === null ||
      sessionStorage.getItem("token") === "null" ||
      sessionStorage.getItem("token") === "undefined" ||
      sessionStorage.getItem("token") === ""
    ) {
      return "";
    }

    return JSON.parse(sessionStorage.getItem("token"));
  }

  public setData(data: User): void {
    this.setStorageToken(data.token);
    this.setStorageUser(data);
    this.setStoragePermissions(data.permisos);
  }

  public failToken(): void {
    this.cleanSession();
  }

  public logout(): void {
    sessionStorage.removeItem('cartItems');
    this.cleanSession();
  }

  private setStorageToken(value: any): void {
    let _value = JSON.stringify(value);
    sessionStorage.setItem("token", _value);
    this.authenticationChanged.next(this.isAuthenticated());
  }

  private setStorageUser(value: any): void {
    let _value = JSON.stringify(value);
    sessionStorage.setItem("user", _value);
    this.authenticationChanged.next(this.isAuthenticated());
  }

  public setStorageCoordinate(coordinates): void {
    let coords = JSON.stringify(coordinates);
    sessionStorage.setItem("coordinates", coords);
  }

  updateUsuario(id: string, form: any): Observable<any> {
    return this.http.put<any>(
      `${environment.API_SECURITY}/api/controlusuarios/${id}`,
      form
    );
  }

  getUsuarioControl(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.API_SECURITY}/api/controlusuarios/${id}`
    );
  }
  private setStoragePermissions(permissions: Array<string>): void {
    let _value = JSON.stringify(permissions);
    sessionStorage.setItem("permissions", _value);
    //this.permissionsService.loadPermissions(permissions);
    this.authenticationChanged.next(this.isAuthenticated());
  }

  public cleanSession() {
    sessionStorage.clear();
  }

  public getUser(): User {
    //console.log(JSON.parse(sessionStorage.getItem('user')));
    return JSON.parse(sessionStorage.getItem("user"));
  }

  public getCoordinates() {
    return JSON.parse(sessionStorage.getItem("coordinates"));
  }

  public getPermissions(): string[] {
    return JSON.parse(sessionStorage.getItem("permissions"));
  }

  public authenticate(body: Credentials): Observable<User> {
    return this.http
      .post<User>(
        environment.API_SECURITY + "/api/Authentication/TokenShop",
        body,
        { observe: 'response' } // Esto es importante para obtener la respuesta completa
      )
      .pipe(
        tap((response: HttpResponse<User>) => {
          const status = response.status;
          this.statusAuth = status;
        }),
        map((response: HttpResponse<User>) => response.body), // Extraer el cuerpo de la respuesta
        catchError(this.handleError)
      );
  }

  
  public activarUsuario(id) {
    return this.http.get(
      environment.API_SECURITY + "/api/Authentication/ActivarUsuario/" + id
    );
  }

  public changePassword(body: ChangePassword): Observable<any> {
    return this.http.put(
      environment.API_SECURITY + "/api/Authentication/CambiarPassword",
      body
    );
  }
  public solicitarCambioPasswordByEmail(correo: string) {
    return this.http
      .get<{ data: string }>(
        environment.API_SECURITY +
          `/api/Authentication/SolicitarReiniciarPassword/${correo}`
      )
      .pipe(
        retry(2),
        map((data) => {
          // this.success.getServersuccessMessage(data, true, 'Added');
          return data;
        }),
        catchError((error) => {
          return throwError(() => new Error(error));
        })
      );
  }
  public ReiniciarPasword(reiniciar: ReiniciarPassword) {
    return this.http
      .post<{ data: string }>(
        environment.API_SECURITY + `/api/Authentication/ReiniciarPassword`,
        reiniciar
      )
      .pipe(
        retry(2),
        map((data) => {
          // this.success.getServersuccessMessage(data, true, 'Added');
          return data;
        })
      );
  }
}
